import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useHousehold } from "@/context/HouseholdContext";
import { api } from "@/lib/api";

export const CATEGORY_LABELS = {
  appliance: "Électroménager", computer: "Informatique", multimedia: "Multimédia", furniture: "Mobilier",
  tools: "Outillage", vehicle: "Véhicule", installation: "Installation", jewelry: "Bijoux & montres", art: "Art & collection", sport: "Sport & loisirs", other: "Autre",
};

export const useAssets = () => {
  const { active } = useHousehold();
  return useQuery({ queryKey: ["assets", active?.id], queryFn: () => api.get(`/households/${active.id}/assets`).then((r) => r.data), enabled: !!active });
};

export const useRooms = () => {
  const { active } = useHousehold();
  return useQuery({ queryKey: ["rooms", active?.id], queryFn: () => api.get(`/households/${active.id}/rooms`).then((r) => r.data), enabled: !!active });
};

export const useBlobUrl = (path) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!path) { setUrl(null); return undefined; }
    let objectUrl;
    api.get(path, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); })
      .catch(() => setUrl(null));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);
  return url;
};

export const usePhotoUrl = (photoId) => {
  const { active } = useHousehold();
  return useBlobUrl(photoId && active ? `/households/${active.id}/files/${photoId}` : null);
};
